import { render, staticRenderFns } from "./InvestmentAdvisoryTab.vue?vue&type=template&id=76bf1f82&"
import script from "./InvestmentAdvisoryTab.vue?vue&type=script&lang=js&"
export * from "./InvestmentAdvisoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports